export const LOGGING_IN = "LOGGING_IN";
export const LOGGING_OUT = "LOGGING_OUT";

export const SET_PRERENDERED = "SET_PRERENDERED";
export const SET_POSTRENDERED = "SET_POSTRENDERED";